import { ReactNode } from 'react';
import { ChevronRight, LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SimpleListItemProps {
  icon: LucideIcon;
  iconColor?: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
  rightContent?: ReactNode;
  className?: string;
}

export function SimpleListItem({
  icon: Icon,
  iconColor = 'text-foreground',
  title,
  subtitle,
  onClick,
  rightContent,
  className
}: SimpleListItemProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex items-center gap-3 py-3 px-4 border-b last:border-b-0",
        "hover:bg-muted/50 transition-colors",
        onClick && "cursor-pointer",
        className
      )}
    >
      {/* Ícone */}
      <div className={cn("flex-shrink-0", iconColor)}>
        <Icon className="h-6 w-6" />
      </div>
      
      {/* Conteúdo */}
      <div className="flex-1 min-w-0">
        <p className="font-medium text-base truncate">{title}</p>
        <p className="text-sm text-muted-foreground truncate">{subtitle}</p>
      </div>
      
      {/* Conteúdo direito ou chevron */}
      {rightContent || (
        onClick && <ChevronRight className="h-5 w-5 text-muted-foreground flex-shrink-0" />
      )}
    </div>
  );
}
